console.log('%cWebsite Made by %cOneDoBit%c https://nedobitkov.com',
    'color: #FFF; background-color: #111; font-size: 16px;', // Style for "Made by"
    'color: #fb9389; background-color: #111; font-size: 16px; font-weight: bold;', // Style for "OneDoBit"
    'color: red; font-size: 16px; background-color: #111;' // Style for the URL
);